import { useEffect } from 'react';
import { trackDigitalEvent } from '@sparknz/tracking';

import { PlanOfferDetails } from '../typings';
import { constructPlanProduct } from '../utils/trackPlanActionLayerView.utils';

export default function useTrackPlanActionLayer(plans: PlanOfferDetails) {
  useEffect(() => {
    trackDigitalEvent({
      event: 'actionLayer.view',
      w3cddl: {
        event: [
          {
            eventInfo: {
              eventName: 'Product Details Choose a Mobile Plan Action Layer',
              eventAction: 'actionLayer.view',
            },
          },
        ],
        product: plans?.map(constructPlanProduct),
      },
    });
  }, []);
}
